const PinterestIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path d='M9.99731 0.333984C4.93797 0.333984 2.25 3.49422 2.25 6.94315C2.25 8.54216 3.1647 10.5356 4.63278 11.1688C4.85465 11.2676 4.97743 11.2247 5.02742 11.0245C5.07039 10.8732 5.26421 10.1352 5.35804 9.78718C5.38699 9.67462 5.37208 9.58011 5.27912 9.47442C4.79151 8.92624 4.40739 7.92438 4.40739 6.98525C4.40739 4.58028 6.36658 2.24662 9.70352 2.24662C12.5879 2.24662 14.605 4.07505 14.605 6.6871C14.605 9.64026 13.001 11.6826 10.9199 11.6826C9.76842 11.6826 8.91072 10.8002 9.17996 9.70985C9.51058 8.40899 10.1525 7.0136 10.1525 6.07533C10.1525 5.23501 9.66493 4.53903 8.67043 4.53903C7.49702 4.53903 6.54636 5.67063 6.54636 7.19318C6.54636 8.15981 6.89804 8.81454 6.89804 8.81454C6.89804 8.81454 5.73866 13.3882 5.52029 14.2388C5.15458 15.6832 5.57028 18.0246 5.60623 18.2256C5.62728 18.3382 5.75707 18.3734 5.82899 18.2815C5.943 18.1337 7.34618 16.1833 7.73731 14.7733C7.88114 14.2603 8.4696 12.175 8.4696 12.175C8.85723 12.8572 9.97275 13.4269 11.1611 13.4269C14.6953 13.4269 17.25 10.3964 17.25 6.63812C17.2307 3.03023 14.0665 0.333984 9.99731 0.333984Z' />
      </svg>
    </span>
  );
};

export default PinterestIcon;
